/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Confirmar from "./Confirmar";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { myHeaders } from "../../config/axios";
import { URL_API } from "../../config/default";
import { useAppContext } from "../../contexts/AppProvider";
import Register from "../Register";

const Reserva = () => {
  const { me } = useAppContext();
  const [payload, setPayload] = useState<any>(null);
  const [form, setForm] = useState<any>(null);



  const decodePayload = async () => {
    // Decodifica el JWT (solo para fines de demostración, no es una validación real)
    const payloadJson: any = localStorage.getItem("reserva");
    const payloadObj = JSON.parse(payloadJson);
    const property = JSON.parse(payloadObj.property);
    property.title = decodeURIComponent(property.title);
    property.description = decodeURIComponent(property.description);

    const fees: any = [];
    property.fees.map((fee: any) => {
      fee = {
        ...fee,
        name: decodeURIComponent(fee.name),
      };
      fees.push(fee);
    });
    property.fees = fees;

    if (payloadObj?.excursion) {
      setPayload({
        firstname: "",
        lastname: "",
        checkin: property.regular_time,
        checkout: property.regular_time,
        start_date: payloadObj.dateRange.startDate,
        end_date: payloadObj.dateRange.endDate,
        date_range: [
          {
            startDate: payloadObj.dateRange.startDate,
            endDate: payloadObj.dateRange.endDate,
            key: "selection",
          },
        ],
        differenceDay: payloadObj.differenceDay,
        tax: "",
        price: property.price,
        guests: payloadObj.guests,
        property: property,
        excursion: payloadObj.excursion,
        type: "Pago unico",
      })
      setForm({
        firstname: "",
        lastname: "",
        checkin: property.regular_time,
        checkout: property.regular_time,
        start_date: payloadObj.dateRange.startDate,
        end_date: payloadObj.dateRange.endDate,
        date_range: [
          {
            startDate: payloadObj.dateRange.startDate,
            endDate: payloadObj.dateRange.endDate,
            key: "selection",
          },
        ],
        differenceDay: payloadObj.differenceDay,
        tax: "",
        price: property.price,
        guests: payloadObj.guests,
        property: property,
        excursion: payloadObj.excursion,
        type: "Pago unico",
      })
    } else {
      setPayload({
        firstname: "",
        lastname: "",
        checkin: property.checkin[0].time,
        checkout: property.checkout[0].time,
        start_date: payloadObj.dateRange.startDate,
        end_date: payloadObj.dateRange.endDate,
        date_range: [
          {
            startDate: payloadObj.dateRange.startDate,
            endDate: payloadObj.dateRange.endDate,
            key: "selection",
          },
        ],
        differenceDay: payloadObj.differenceDay,
        tax: "",
        price: property.price,
        guests: payloadObj.guests,
        property: property,
        excursion: payloadObj.excursion,
        type: "Pago unico",
      });
      setForm({
        firstname: "",
        lastname: "",
        checkin: property.checkin[0].time,
        checkout: property.checkout[0].time,
        start_date: payloadObj.dateRange.startDate,
        end_date: payloadObj.dateRange.endDate,
        date_range: [
          {
            startDate: payloadObj.dateRange.startDate,
            endDate: payloadObj.dateRange.endDate,
            key: "selection",
          },
        ],
        differenceDay: payloadObj.differenceDay,
        tax: "",
        price: property.price,
        guests: payloadObj.guests,
        property: property,
        excursion: payloadObj.excursion,
        type: "Pago unico",
      })
    }
  }

  useEffect(() => {
    if (!payload && !form) {
      decodePayload();
    }
  }, [])



  const { isPending: isPendingCommission, error: errorCommission, data: commission } = useQuery({
    queryKey: ["commissions"],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      return fetch(`${URL_API}/commissions/1`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => res.json());
    },
  });

  if (errorCommission) return ""

  if (isPendingCommission || !payload || !form) return "";

  if (!me) {
    return (
      <div className="mx-auto border-0 w-[100%] md:w-[80%]">
        <Register />
      </div>
    );
  }

  return (
    <div className="mx-auto border-0 w-[100%] md:w-[80%]">
      <Confirmar
        data={{
          ...payload,
          firstname: me.firstname,
          lastname: me.lastname,
        }}
        setForm={setForm}
        form={form}
        user={me}
        commission={commission?.data?.value ?? 0}
      />
    </div>
  );
};

export default Reserva;
